import styled from 'styled-components';

export const StyledForm = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  height: 100%;
`;

export const StyledFilterButtons = styled.div`
  display: flex;
  justify-content: space-evenly;
  flex-direction: column;
  width: 200px;
  height: 100%;
  margin: 10px;
`;

export const StyledFilterFields = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 10px 0;

  .ant-form-item {
    width: 375px;
    padding: 0 10px;
    margin-bottom: 10px;
  }

  .ant-form-item-label {
    width: 150px;
    text-align: left;
  }

  .ant-form-item-control {
    width: 250px;
  }
`;

export const StyledTopBar = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
`;

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  height: 100%;

  .resiliency-filter-form {
    height: 100%;
    width: 100%;
  }
`;
